import { render } from "./FormSection.vue?vue&type=template&id=7b135a0b"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
script.render = render

export default script